module.exports = __webpack_public_path__ + "static/media/cover8.4fab81eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover8.png
// module id = 561
// module chunks = 0